import PropertiesDashboard from './PropertiesDashboard';

export default PropertiesDashboard; 